import { LocationType } from '@wix/ambassador-bookings-services-v2-service/types';
export const mapBasketToCalendarSelections = basket => {
  const location = basket.location.type === LocationType.BUSINESS ? basket.location.value : undefined;
  return {
    location,
    services: basket.selectedServicesPreferences.map(servicePreferences => {
      var _servicePreferences$v;
      return {
        id: servicePreferences.service.id,
        resources: Object.values(servicePreferences.resources)[0] || [],
        variants: servicePreferences.variant && !((_servicePreferences$v = servicePreferences.variant.choices) != null && _servicePreferences$v[0].staffMemberId) ? [servicePreferences.variant] : undefined
      };
    })
  };
};
//# sourceMappingURL=mapBasketToCalendarSelections.js.map